import { b2cScope } from "../../constants/Config";

export const loginScope = () => {
  const scope = {
    scopes: [b2cScope]
  };
  return scope;
};

export const msalConfig = (data: any) => {
  const auth = {
    auth: {
      clientId: data.REACT_APP_PORTAL_CLIENT,
      authority: data.REACT_APP_PORTAL_LOGINURL,
      knownAuthorities: [data.REACT_APP_PORTAL_KNOWN_AUTHORIETIES],
      redirectUri: data.REACT_APP_PORTAL_REDIRECT_URI,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    }
  };
  return auth;
};

export const loginRequest = loginScope()